<template >
    <div class="nav" :class="{fixed:fixedTrue}">
        <div class="container nav__head">
            <a href="#!"><img :src="navLogo" alt="" class="nav__head-logo"></a>
            <a href="https://www.google.com/maps/search/arko+mebel/@41.3037583,69.3142225,16.69z?hl=ru-KG" target="_blank" class="nav__head-locatsion">
                <img src="../../assets/img/location.svg" alt="">
                <p>Tashkent. Cholonzor 21 uy</p>
            </a>
            <a href="tel:8 (961) 525 91 91" class="nav__head-kontak">
                <img :src="navPhone" alt="">
                <p>8 (961) 525 91 91</p>
            </a>
            <div class="nav__head-info">
                <a href="#!" class="nav__head-info__user">
                    <img src="../../assets/img/user.svg" alt="">
                    <p>kirish</p>
                </a>
                <a href="#!" class="nav__head-info__user" @click="$emit('heartTrue',true)">
                    <span v-if="icon" class="icon">
                        {{ heart.length }}
                    </span>
                    <img src="../../assets/img/hart.svg" alt="">
                    <p>Like</p>
                </a>
                <a href="#!" class="nav__head-info__user" @click="$emit('shopTrue',true)">
                    <span v-if="iconShop" class="icon">
                        {{ shop.length }}
                    </span>
                    <img src="../../assets/img/shopping-cart.svg" alt="">
                    <p>savat</p>
                </a>
            </div>
        </div>
        <div class="nav__sec">
            <img @click="addNav" class="nav__box-bars" src="../../assets/img/menu-bar.png" alt="">
            <div class="nav__box" :class="{h100:navHeight}">
                <ul class="container nav__box-list" :class="{dflex:navHeight}">
                    <li v-for="list,i in navList" :key="i">
                        <a @click="cartList(list.filter), navHeight = false" href="#!" class="nav__box-list__link">{{list.list}}</a>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    props:{
        navList:Array,
        icon:Boolean,
        heart:Array,
        iconShop:Boolean,
        shop:Array,
    },
    data() {
        return {
            navLogo: require("@/assets/img/arko-mebel-logo.png"),
            navPhone: require("@/assets/img/phone.svg"),
            navHeight:false,
            fixedTrue:false,
        }
    },
    methods:{
        addNav(){
            this.navHeight = !this.navHeight
        },
        cartList(filter){
            this.$emit('cartList',{
                bool: true,
                filter:filter
            });
        }
    },
    mounted() {
        let nav = document.querySelector('.nav');
        window.addEventListener("scroll", (el)=>{
            // console.log(nav.clientHeight);
            if (window.scrollY > 170) {
                nav.style = `position:fixed; top:0; z-index: 100; background:#fff;`
            }else{
                nav.style = `position:none;`
            }
            this.$emit('navH',nav.clientHeight)
            // this.navHeight = nav.clientHeight
        });
        
    },
}
</script>
<style lang="scss">
</style>